<div>
<app-loader></app-loader>
</div>

<div class="lightGray main" [ngClass]="{'headerFixed': flag, 'lightGray': bgClassAdded}">
    <app-header *ngIf="isHeaderFooterShow"></app-header>
</div>

<router-outlet></router-outlet>


<app-footer *ngIf="isHeaderFooterShow"></app-footer>
